module.exports = __webpack_public_path__ + "img/14.23b4046e.jpg";